export const pageSearch = {
 
}

export default {
  'reward_number': {
    title: '奖励编号',
    type: 'input',
  },
  'reward_id': {
    title: '项目类型编码',
    type: 'input',
  },
  'reward_name': {
    title: '项目类型描述',
    type: 'input',
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'customer_name': {
    title: '客户名称',
    type: 'input',
  },
  'sal_center': {
    describe: true,
    suffix:'_text',
    title: '营销大区',
    type: 'select',
    dictionary: 'sale'
  },
  'bp_role': {
    suffix:'_text',
    title: '奖励角色类型',
    describe: true,
    type: 'select',
    dictionary: 'A0079'
  },
  'amount': {
    title: '奖励总金额(元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amount': {
    title: '已占用金额(元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amount': {
    title: '已开票金额(元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amount': {
    title: '剩余金额(元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'status': {
    title: '状态',
    slot: true,
    describe: true,
    type: 'select',
    dictionary: 'A0080'
  },
  'remark': {
    title: '备注',
    type: 'input',
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    valueFormat: 'yyyy-MM-dd'
  },
  'uname_text': {
    title: '创建人',
    type: 'input',
  },
}


// WEBPACK FOOTER //
// ./src/views/reward-policy/config/rewardCustomer.js